import { render, staticRenderFns } from "./RoundFixrate.vue?vue&type=template&id=0469a6a5&scoped=true&"
import script from "./RoundFixrate.vue?vue&type=script&lang=js&"
export * from "./RoundFixrate.vue?vue&type=script&lang=js&"
import style0 from "./RoundFixrate.vue?vue&type=style&index=0&id=0469a6a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469a6a5",
  null
  
)

export default component.exports